<template>
  <div>
    <basic-container>
      <div>
        <el-form :model="goodsForm">
          <!-- 产品名称 -->
          <el-form-item label="产品名称" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.name" placeholder="请输入产品名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品价格" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.price" placeholder="请输入产品价格" clearable></el-input>
          </el-form-item>
          <el-form-item label="采购价" style="display: flex;width:300px;">
            <el-input v-model.number="goodsForm.purchasePrice" type="number" step="0.01" placeholder="请输入采购价" clearable></el-input>
          </el-form-item>
          <el-form-item label="平方用量" style="display: flex;width:300px;">
            <el-input v-model.number="goodsForm.areaUsage" type="number" step="0.01" placeholder="请输入平方用量" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item label="返利金额" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.rebate" placeholder="请输入返利金额" clearable></el-input>
          </el-form-item>
          <el-form-item label="推广费用" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.laborCost" placeholder="请输入推广费" clearable></el-input>
          </el-form-item> -->
          <!-- 换新提醒配置 -->
          <!-- <el-form-item label="换新提醒配置">
            <el-table :data="goodsFormData" border style="width: 100%; margin-top: 20px">
              <el-table-column prop="name" label="显示名称" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" placeholder="请输入名称" clearable></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="time" label="到期时间" min-width="150">
                <template slot-scope="scope">
                  <div style="display: flex; align-items: center;">
                    <el-input v-model.number="scope.row.time" placeholder="请输入到期时间" type="number" min="1"
                      clearable></el-input>
                    <el-select v-model="scope.row.unit" placeholder="请选择时间单位" clearable style="margin-right: 10px;">
                      <el-option v-for="unit in units" :key="unit.value" :label="unit.valueName"
                        :value="unit.value"></el-option>
                    </el-select>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                  <el-button type="danger" icon="el-icon-close" size="small"
                    @click="handleSteppingDelete(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="配置" width="150">
                <template slot-scope="scope">
                  <el-button type="warning" icon="el-icon-plus" size="small"
                    @click="handleAddRows(scope.$index)">增加一行</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item> -->
        </el-form>
        <!-- <el-form :model="dynamicForm">
          <el-form-item label="动态表单配置">
            <el-table :data="dynamicFormData" border style="width: 100%; margin-top: 20px">
              <el-table-column prop="fieldName" label="显示名称" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.fieldName" placeholder="请输入名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="inputType" label="控件类型" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.inputType" placeholder="请选择控件类型" clearable>
                    <el-option v-for="inputType in inputTypes" :key="inputType.id" :label="inputType.name"
                      :value="inputType.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="dataSource" label="数据源" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.dataSource" placeholder="请选择数据源" clearable>
                    <el-option v-for="dataSource in dataSources" :key="dataSource.id" :label="dataSource.valueName"
                      :value="dataSource.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="isNull" label="是否为空" width="150">
                <template slot-scope="scope">
                  <el-radio-group v-model="scope.row.isNull">
                    <el-radio label="YES">是</el-radio>
                    <el-radio label="NO">否</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column prop="sort" label="排序" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.sort"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                  <el-button type="danger" icon="el-icon-close" size="small"
                    @click="handleSteppingDelete1(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="配置" width="150">
                <template slot-scope="scope">
                  <el-button type="warning" icon="el-icon-plus" size="small"
                    @click="handleAddRows1(scope.$index)">增加一行</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form> -->
      </div>
      <div style="width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px">
        <el-button type="danger" size="small" @click="goBack" icon="el-icon-circle-close-outline">返回</el-button>
        <el-button type="primary" size="small" icon="el-icon-circle-check-outline" @click="submit">提交</el-button>
      </div>
    </basic-container>
  </div>
</template>



<script>
import {
  addGoods
} from "@/api/work/waterProof/purWaterGoods";
import { DIC } from "@/const/dic";
import {
  findDataSourceFields,
  findDataSourceAll,
} from "@/api/work/dynamicForm";
export default {
  data() {
    return {
      isPas: false,
      units: [
        { value: 'DAY', valueName: '天' },
        { value: 'MOON', valueName: '月' },
        { value: 'YEAR', valueName: '年' },
      ],
      goodsForm: {
        name: '',
        purchasePrice: '',
        areaUsage: '',
        // rebate: '',
        formType: ''
      },
      goodsFormData: [], // 确保这是一个数组
      categoryTypes: [],
      inputTypes: [],
      dataSources: [],
      agentIds: [],
      auditors: DIC.SERVICEITEM_AUDITOR,
      clientTypes: DIC.SERVICEITEM_TYPE,
      dynamicForm: {
      },
      dynamicTypes: [], // 确保这是一个数组
      dynamicFormData: [] // 确保这是一个数组
    };
  },
  created() {
    // 初始化goodsTimeInfo
    this.goodsTimeInfo();
    findDataSourceFields().then(res => {
      let data = JSON.parse(res.data);
      this.inputTypes = data;
    });
    findDataSourceAll().then(res => {
      let data = JSON.parse(res.data);
      this.dataSources = data.rows;
    });
    this.initDynamicFormData();
  },
  methods: {
    initDynamicFormData() {
      // 初始化dynamicFormData
      this.dynamicFormData = [{
        fieldName: '',
        inputType: '',
        dataSource: '',
        isNull: '',
        sort: ''
      }];
    },
    goodsTimeInfo() {
      this.goodsForm.name = '';
      this.goodsForm.purchasePrice = '';
      this.goodsForm.areaUsage = '';
      // this.goodsForm.rebate = '';
      // 初始化goodsFormData
      this.goodsFormData = [{
        name: '',
        time: '',
        unit: '',
      }];
    },
    goBack() {
      let item = {
        close: true,
        label: "新增净水产品",
        value: "/work/waterProof/purWaterGoods/add"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1);
    },
    submit() {
      // 构建提交的数据结构
      const submitData = {
        type: 'WATERPROOF',
        name: this.goodsForm.name,
        price: this.goodsForm.price,
        purchasePrice: this.goodsForm.purchasePrice,
        areaUsage: this.goodsForm.areaUsage,
        filtersL:[]
       /*  // rebate: this.goodsForm.rebate,
        // laborCost: this.goodsForm.laborCost,
        filters: this.goodsFormData.map(field => ({
          name: field.name,
          time: field.time,
          unit: field.unit,
        }))
      };
      // 构建提交的数据结构
      const dynamicFormRequest = {
        fields: this.dynamicFormData.map(field => ({
          fieldName: field.fieldName,
          inputType: field.inputType,
          dataSource: field.dataSource,
          sort: field.sort,
          isNull: field.isNull
        })) */
      };
      // 将动态表单dynamicFormRequest数据放到submitData中
      // submitData.dynamicFormRequest = dynamicFormRequest;
      addGoods(submitData).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          // 返回上一页
          this.$router.go(-1);
        } else {
          if (!this.isPas) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            this.isPas = true;
            setTimeout(() => {
              this.isPas = false;
            }, 1000);
          }
        }
      });
    },
    handleSteppingDelete1(index) {
      if (this.dynamicFormData.length == 1) {
        this.$message({
          showClose: true,
          message: "动态表单不能为空",
          type: "error"
        });
      } else {
        this.dynamicFormData.splice(index, 1);
      }
    },
    handleAddRows1() {
      this.dynamicFormData.push({
        fieldName: '',
        inputType: '',
        dataSource: '',
        isNull: '',
        sort: ''
      });
    },
    handleSteppingDelete(index) {
      if (this.goodsFormData.length == 1) {
        this.$message({
          showClose: true,
          message: "动态产品不能为空",
          type: "error"
        });
      } else {
        this.goodsFormData.splice(index, 1);
      }
    },
    handleAddRows() {
      this.goodsFormData.push({
        name: '',
        time: '',
        unit: '',
      });
    }
  }
};
</script>

<style></style>